import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

// Brand focus ring styles using CSS variables (avoids broken theme-tools color functions)
export const brandFocusRing = (props: StyleFunctionProps) => ({
  borderColor: mode('brand.500', 'brand.200')(props),
  boxShadow: mode(
    '0px 0px 0px 1px var(--chakra-colors-brand-500)',
    '0px 0px 0px 1px var(--chakra-colors-brand-200)'
  )(props),
})

// Combined focus and focusVisible styles (they're usually identical)
export const brandFocusStyles = (props: StyleFunctionProps) => ({
  _focus: brandFocusRing(props),
  _focusVisible: brandFocusRing(props),
})

// Common outline field styles for inputs, selects, number inputs
export const outlineFieldStyles = (props: StyleFunctionProps) => ({
  borderRadius: 'lg',
  bg: mode('white', 'gray.800')(props),
  _hover: { borderColor: mode('gray.300', 'gray.600')(props) },
  _invalid: {
    borderColor: 'error',
    boxShadow: '0 0 0 1px var(--chakra-colors-error)',
  },
  ...brandFocusStyles(props),
})
